import { useState } from "react";
import {
  Flex,
  notification,
  TimePicker,
  Typography,
  Calendar,
  theme,
} from "antd";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import "./styles.css";
import { StyledButton } from "Components/Button/StyledButton";
import { useMutation } from "@tanstack/react-query";
import { publishSlot } from "./apis/publishSlots";
import { MyCalendar } from "Features/MyCalendar/MyCalendar";
import queryClient from "QueryClient/queryClient";

dayjs.extend(utc);
dayjs.extend(timezone);

export const PublishSlots = () => {
  const { token } = theme.useToken();
  const { Title } = Typography;
  const [api, contextHolder] = notification.useNotification();

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [localStartTime, setLocalStartTime] = useState(null);
  const [startTimeUTC, setStartTimeUTC] = useState(null);
  const [endTimeUTC, setEndTimeUTC] = useState(null);

  const addSlotMutation = useMutation({
    mutationFn: publishSlot,
    onSuccess: () => {
      api.success({
        message: "Success",
        description: "Slot added successfully",
      });
      // Reset form
      setSelectedDate(null);
      setLocalStartTime(null);
      setStartTimeUTC(null);
      setEndTimeUTC(null);
      queryClient.invalidateQueries({ queryKey: ["getSlots"] });
    },
    onError: () => {
      api.error({
        message: "Error",
        description: "We have an error adding your slot",
      });
    },
  });

  const disablePastDates = (current) =>
    current && current < dayjs().startOf("day");

  const onDateSelect = (value) => {
    setSelectedDate(value.startOf("day"));
  };

  const handleStartTimeChange = (time) => {
    setLocalStartTime(time);

    if (selectedDate && time) {
      const combinedStart = selectedDate
        .hour(time.hour())
        .minute(time.minute());

      const combinedEnd = combinedStart.add(30, "minute");

      setStartTimeUTC(combinedStart.utc());
      setEndTimeUTC(combinedEnd.utc());
    } else {
      setStartTimeUTC(null);
      setEndTimeUTC(null);
    }
  };

  const wrapperStyle = {
    width: 300,
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
    flex: 1,
  };

  return (
    <Flex vertical justify="top" align="center" style={{ height: "100%" }}>
      {contextHolder}
      <Title level={3}>
        Please select a date and time. Each appointment will be 30 minutes.
      </Title>
      <Flex
        justify="space-evenly"
        align="flex-start"
        style={{ width: "100%", marginTop: "2em" }}
      >
        <div style={wrapperStyle} className="appointments-item">
          <Calendar
            fullscreen={false}
            onSelect={onDateSelect}
            value={selectedDate}
            disabledDate={disablePastDates}
          />
        </div>

        <div className="appointments-item appointments-time-picker">
          <TimePicker
            onChange={handleStartTimeChange}
            value={localStartTime}
            format="HH:mm"
            placeholder="Select Start Time"
          />
        </div>
      </Flex>

      {
        <StyledButton
          disabled={!startTimeUTC || !endTimeUTC || !selectedDate}
          onClick={() =>
            addSlotMutation.mutate({
              startTime: startTimeUTC.toISOString(),
              endTime: endTimeUTC.toISOString(),
            })
          }
          style={{ marginTop: "2em" }}
        >
          Publish
        </StyledButton>
      }
      <Title level={3} style={{ marginTop: "2em" }}>
        View My Calendar
      </Title>
      <MyCalendar />
    </Flex>
  );
};
